import { useEffect, useState } from "react";
import CityEscapeFlowChart from "../components/CityEscapeFlowChart/CityEscapeFlowChart";
import { useFullCityEscapeData } from "../hooks";
import { MatchFilter } from "../libs/statsFilters";
import { OpenModalProps, useDialog } from "./DialogProvider";

export type CityEscapeFlowOpenModalProps = {
  title?: string;
  filters?: MatchFilter;
  loading?: boolean;
  cityEscapeId?: string;
};

function CityEscapeFlowDialogTitle(props: CityEscapeFlowOpenModalProps) {
  return (
    <span>
      Flow: <b>{props.title}</b>
    </span>
  );
}

function CityEscapeFlowDialogContent(props: CityEscapeFlowOpenModalProps) {
  const cityEscape = useFullCityEscapeData(props.cityEscapeId);
  return (
    cityEscape.data && (
      <CityEscapeFlowChart
        cityEscape={cityEscape.data}
        filters={props.filters}
        lang={"it-IT"}
        height="75vh"
        width="1000px"
        direction="DOWN"
        controls={true}
        minimap={true}
        defaultZoom={0.5}
      />
    )
  );
}

export function useCityEscapeFlowDialog(id?: string) {
  const dialog = useDialog();
  const dialogId = id ?? "city-escape-flow-dialog";
  const [props, setProps] = useState<CityEscapeFlowOpenModalProps | null>(null);

  useEffect(() => {
    const startingProps: OpenModalProps = {
      loading: true,
      slotProps: { dialog: { maxWidth: "lg" } },
    };

    dialog.create(dialogId, startingProps, { onConflict: "replace" });
  }, []);

  const openModal = (props: CityEscapeFlowOpenModalProps) => {
    console.log("opening dialog", props);

    dialog.open(dialogId, {
      loading: props.loading,
      title: <CityEscapeFlowDialogTitle {...props} />,
      content: <CityEscapeFlowDialogContent {...props} />,
      slotProps: { dialog: { maxWidth: "lg" } },
    });

    setProps(props);
  };

  const close = () => {
    dialog.remove(dialogId);
  };

  return {
    openModal,
    close,
  };
}
